(function () {
const { algoliasearch: $02a59f831d44c109$var$algoliasearch, instantsearch: $02a59f831d44c109$var$instantsearch } = window;
jQuery(function($) {
    function getSnippetAttr(hit) {
        if (!hit._snippetResult) return "";
        const keys = [
            "modules_0_text",
            "headline",
            "body_copy"
        ]; // preferred order
        for (const key of keys){
            const content = hit._snippetResult[key]?.value?.trim();
            if (content) return key;
        }
        return Object.keys(hit._snippetResult)[0] || "";
    }
    console.log("Algolia with WordPress: Initializing search...");
    const fi = awpsettings.indices[0];
    const featuredVisibilityTracker = new Map();
    function getSearchInstance(container) {
        console.log("get instance");
        const searchClient = $02a59f831d44c109$var$algoliasearch(awpsettings.creds.application_id, awpsettings.creds.search_key);
        const search = $02a59f831d44c109$var$instantsearch({
            indexName: fi.name,
            searchClient: searchClient,
            future: {
                preserveSharedStateOnUnmount: true
            },
            debug: false,
            insights: true,
            searchFunction: (helper)=>{
                const blacklist = [
                    "vipreg",
                    "/index/\\thinkapp/invokefunction"
                ];
                const searchQuery = helper.state.query.trim();
                if (!searchQuery || blacklist.some((item)=>new RegExp(item, "i").test(searchQuery))) return;
                helper.search();
            }
        });
        $(`${container} .algolia-${fi.name}`).show();
        search.addWidgets([
            $02a59f831d44c109$var$instantsearch.widgets.searchBox({
                container: `${container} .searchbox`,
                placeholder: "Search"
            }),
            $02a59f831d44c109$var$instantsearch.widgets.pagination({
                container: `${container} .pagination`,
                padding: 1
            })
        ]);
        awpsettings.indices.forEach((val)=>{
            const featuredIndex = $02a59f831d44c109$var$instantsearch.widgets.index({
                indexName: val.name
            });
            featuredIndex.addWidgets([
                $02a59f831d44c109$var$instantsearch.widgets.configure({
                    filters: "algolia_featured=1",
                    hitsPerPage: 5
                }),
                $02a59f831d44c109$var$instantsearch.widgets.hits({
                    container: `${container} .featured-hits-${val.name}`,
                    templates: {
                        item: (hit, { html: html, components: components })=>{
                            const body_copy = getSnippetAttr(hit);
                            return html`<article data-id="${hit.ID}">
                <a
                  href="${hit.permalink}"
                  title="${hit.post_title}"
                  data-id="${hit.ID}"
                >
                  <div class="img-wrap">
                    <img
                      src="${hit.thumbnail}"
                      height="50"
                      width="50"
                      alt="${hit.post_title}"
                    />
                  </div>
                  <div id="txt-wrap">
                    <h4>
                      ${components.Highlight({
                                hit: hit,
                                attribute: "post_title"
                            })}
                    </h4>
                    <p>
                      ${components.Snippet({
                                hit: hit,
                                attribute: body_copy
                            })} <em
                        >read more</em
                      >
                    </p>
                  </div>
                </a>
              </article>`;
                        }
                    },
                    transformItems (items) {
                        const section = document.querySelector(`${container} .featured-${val.name}`);
                        if (section) section.style.display = items.length ? "block" : "none";
                        featuredVisibilityTracker.set(val.name, items.length > 0);
                        if (featuredVisibilityTracker.size === awpsettings.indices.length) {
                            const featuredResults = document.querySelector(`${container} #featured-results`);
                            if (featuredResults) {
                                const hasVisible = Array.from(featuredVisibilityTracker.values()).some(Boolean);
                                featuredResults.style.display = hasVisible ? "block" : "none";
                            }
                            featuredVisibilityTracker.clear();
                        }
                        return items;
                    }
                })
            ]);
            search.addWidgets([
                featuredIndex
            ]);
        });
        awpsettings.indices.forEach((val)=>{
            $(`${container} .algolia-${val.name}`).show();
            const index = $02a59f831d44c109$var$instantsearch.widgets.index({
                indexName: val.name
            });
            index.addWidgets([
                $02a59f831d44c109$var$instantsearch.widgets.configure({
                    hitsPerPage: val.count,
                    filters: "NOT algolia_featured=1"
                }),
                $02a59f831d44c109$var$instantsearch.widgets.hits({
                    container: `${container} .${val.name}-hits`,
                    templates: {
                        item: (hit, { html: html, components: components })=>{
                            const body_copy = getSnippetAttr(hit);
                            return html`<article data-id="${hit.ID}">
                <a
                  href="${hit.permalink}"
                  title="${hit.post_title}"
                  data-id="${hit.ID}"
                >
                  <div class="img-wrap">
                    <img
                      src="${hit.thumbnail}"
                      height="50"
                      width="50"
                      alt="${hit.post_title}"
                    />
                  </div>
                  <div id="txt-wrap">
                    <h4>
                      ${components.Highlight({
                                hit: hit,
                                attribute: "post_title"
                            })}
                    </h4>
                    <p>
                      ${components.Snippet({
                                hit: hit,
                                attribute: body_copy
                            })} <em
                        >read more</em
                      >
                    </p>
                  </div>
                </a>
              </article>`;
                        }
                    }
                })
            ]);
            search.addWidgets([
                index
            ]);
        });
        return search;
    }
    const searcha = $(".when-unstuck").length ? getSearchInstance(".when-unstuck") : undefined;
    const searchb = $(".when-stuck .searchbox").length ? getSearchInstance(".when-stuck") : undefined;
    const searchc = $(".body-search").length ? getSearchInstance(".body-search") : undefined;
    const searchd = $(".mobile-search").length ? getSearchInstance(".mobile-search") : undefined;
    searcha?.start();
    searchb?.start();
    searchc?.start();
    searchd?.start();
    function registerRenderCallback(container, instance) {
        if (!instance) return;
        instance.on("render", ()=>{
            $(`${container} .results > div`).show();
            $("#noResults").remove();
            $(`${container} .ais-Hits--empty`).parent().parent().hide();
            if ($(`${container} .ais-Hits-item:visible`).length < 1) $(`${container} .pagination`).before("<p id='noResults'>no results</p>");
            $(`${container} .ais-Hits-item`).each(function() {
                const $article = $(this).find("article");
                const $link = $article.find("a");
                const id = $link.attr("data-id") || $article.data("id");
                if (id) {
                    $link.attr("data-id", id);
                    $article.css({
                        display: "flex",
                        alignItems: "center"
                    });
                }
            });
            // ✅ Moved here — inside render callback
            const featuredResults = document.querySelector(`${container} #featured-results`);
            if (featuredResults) {
                const anyVisible = Array.from(featuredResults.querySelectorAll(":scope > div")).some((el)=>el.offsetParent !== null);
                featuredResults.style.display = anyVisible ? "block" : "none";
            }
        });
    }
    registerRenderCallback(".when-unstuck", searcha);
    registerRenderCallback(".when-stuck", searchb);
    registerRenderCallback(".body-search", searchc);
    registerRenderCallback(".mobile-search", searchd);
    $(document).on("click", "#ssme-search", ()=>{
        $(".mobile-search").toggle();
        $(".mobile-header-wrapper > .container > .row:first-child").toggle();
        $(".mobile-search .ais-SearchBox-input").focus();
    });
    $(document).on("click", ".ais-SearchBox-reset", ()=>{
        $(".mobile-search").toggle();
        $(".mobile-header-wrapper > .container > .row:first-child").toggle();
    });
    $(".searchbox").on("keyup", (ev)=>{
        if (ev.target.value.trim().length > 0) $(ev.currentTarget).siblings(".results").show();
    });
    $(".searchbox").on("keydown", (ev)=>{
        if (ev.key === "Enter" || ev.keyCode === 13) window.location.href = "/?s=" + $(ev.target).val();
    });
    $(document).on("click", (ev)=>{
        if (!$(ev.target).closest(".algolia-with-wordpress.dropdown").length) $(".results").hide();
    });
});

})();
//# sourceMappingURL=app.js.map
